/** Where a session's standalone board lives. */
export function boardPath(sessionId: string): string {
    return `/emdr/session/${sessionId}`;
}

/** The patient's screen of that board, opened in a second window. */
export function patientScreenPath(sessionId: string): string {
    return `${boardPath(sessionId)}/patient`;
}
